var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.667 2.66666H12.0003C12.3539 2.66666 12.6931 2.80713 12.9431 3.05718C13.1932 3.30723 13.3337 3.64637 13.3337 3.99999V13.3333C13.3337 13.6869 13.1932 14.0261 12.9431 14.2761C12.6931 14.5262 12.3539 14.6667 12.0003 14.6667H4.00033C3.6467 14.6667 3.30756 14.5262 3.05752 14.2761C2.80747 14.0261 2.66699 13.6869 2.66699 13.3333V3.99999C2.66699 3.64637 2.80747 3.30723 3.05752 3.05718C3.30756 2.80713 3.6467 2.66666 4.00033 2.66666H5.33366",
    stroke: "#ACACBE",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.99967 1.33334H5.99967C5.63148 1.33334 5.33301 1.63182 5.33301 2.00001V3.33334C5.33301 3.70153 5.63148 4.00001 5.99967 4.00001H9.99967C10.3679 4.00001 10.6663 3.70153 10.6663 3.33334V2.00001C10.6663 1.63182 10.3679 1.33334 9.99967 1.33334Z",
    stroke: "#ACACBE",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.2d0e2d5bbe04fe3b9b83614aa0e2d832.svg";
export { ForwardRef as ReactComponent };